module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-47.137a80fe.png";